import { render, staticRenderFns } from "./AboutNeobanxPage.vue?vue&type=template&id=283e4744&scoped=true&"
import script from "./AboutNeobanxPage.vue?vue&type=script&lang=ts&"
export * from "./AboutNeobanxPage.vue?vue&type=script&lang=ts&"
import style0 from "./AboutNeobanxPage.vue?vue&type=style&index=0&id=283e4744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283e4744",
  null
  
)

export default component.exports